export * from './news-list.schema';
export * from './get-news.schema';